/* Carbon District — CD 2026 motion. Scroll progress, staggered reveals, hero spotlight,
   flagship parallax, steps line. Skips all motion under prefers-reduced-motion. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init() {
    if (!document.querySelector('.cd26-progress')) {
      var bar = document.createElement('div'); bar.className = 'cd26-progress'; bar.setAttribute('aria-hidden', 'true'); document.body.appendChild(bar);
    }
    var bar2 = document.querySelector('.cd26-progress');
    document.querySelectorAll('.cd26-grid,.cd26-makes,.cd26-steps,.cd26-builds').forEach(function (g) {
      Array.prototype.forEach.call(g.children, function (c, i) { c.style.setProperty('--d', (i % 8) * 0.07 + 's'); });
    });
    var els = document.querySelectorAll('.cd26-rv:not(.is-in),.cd26-steps:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); }
    else {
      var io = new IntersectionObserver(function (ents) { ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (e) { io.observe(e); });
    }
    var feat = document.querySelector('.cd26-feature__img img'), ticking = false;
    function onScroll() {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var h = document.documentElement, p = h.scrollTop / Math.max(1, h.scrollHeight - h.clientHeight);
        if (bar2) bar2.style.transform = 'scaleX(' + p + ')';
        if (feat && !reduce) {
          var r = feat.parentElement.getBoundingClientRect(), t = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
          feat.style.transform = 'scale(1.1) translateY(' + (-t * 40).toFixed(1) + 'px)';
        }
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    if (reduce) return;
    document.querySelectorAll('.cd26-hero').forEach(function (hero) {
      if (hero.dataset.cd26) return; hero.dataset.cd26 = '1';
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        hero.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        hero.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
